module.exports = __webpack_public_path__ + "img/OA.3c12f5dc.png";